import React from 'react';
import PropTypes from 'prop-types';

/** An inline svg component. */
const Amex = ({
  size = 16,
  height = 22,
  width = 21,
  svgRef,
  title,
  style = {},
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 30 30"
      height={height || size}
      width={width || size}
      ref={svgRef}
      aria-labelledby={title ? title : undefined}
      style={{ pointerEvents: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      {title ? <title id={title}>{title}</title> : null}

      <g>
        <path
          id="Page 1"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.0625 12V18.5625H22.3125V17.1572H18.5625V15.9375H22.125V14.5312H18.5625V13.4062H22.3125V12H17.0625ZM13.4062 12L11.9062 16.2188L10.4062 12H7.6875V18.4406L4.96875 12.1875H2.8125V12.0938L0 18.75H1.875L2.34375 17.5303H5.4375L5.90625 18.6562H7.78125L7.69969 18.4678H9.375V13.6875L11.0625 18.4678H12.4688L14.1562 13.6875V18.4678H16.0312V12H13.4062ZM3.84467 13.5938L4.78123 15.9375H2.90717L3.84467 13.5938ZM28.0322 12.0938L26.5312 14.0634L25.0322 12.0938H23.0625L25.6884 15.375L23.0625 18.6562H25.0322L26.5312 16.6875L28.0322 18.6562H30.0009L27.3759 15.375L30.0009 12.0938H28.0322Z"
          fill="#016FD0"
        />
      </g>
    </svg>
  );
};

Amex.propTypes = {
  /** Optional class name to apply to `svg` element. */
  className: PropTypes.string,
  /** Height of `svg`. */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Gets applied to both `height` and `width` of `svg`. */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Use if you want to get a `ref` to the `svg` element. */
  svgRef: PropTypes.func,
  /** For accessability. Allows icons in buttons etc. to be read by screen readers. */
  title: PropTypes.string,
  /** Width of `svg`. */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { Amex };
